export default __webpack_public_path__ + "static/media/img_about1@2x.min.61493e6f.jpg";